// app/error.js
'use client';

import { useEffect } from 'react';
import { useTranslations } from 'next-intl';

import EmptyPage, { EEmptyPageType } from '@/components/empty-page';
import { reportException } from '@/utils/arms';

export default function Error({ error }: { error: Error }) {
    const t = useTranslations('Common');

    // 上传自定义错误日志
    useEffect(() => {
        reportException(error.name, error.message, {
            stack: error.stack,
        });
    }, [error]);

    return <EmptyPage tips={t('network_error')} type={EEmptyPageType.ERROR} />;
}
